import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
/* 在app打开按钮组件
 * <component-open-app v-if="!isAPP"></component-open-app>
 * componentCenter.openApp.showOpenAppBtn=true; //显示
 * componentCenter.openApp.showOpenAppBtn=false; //隐藏
 */

export default {
  name: 'appDownload',
  data: function data() {
    return {
      showOpenAppBtn: false //云客赞app下载栏，默认展示
    };
  },

  mounted: function mounted() {
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    window.componentCenter.openApp = this;
    console.log("ycf组件初始化：open_app");
    YCF_Plugin.linkedmeInit({
      btnQueue: {
        $elem: $(".component-open-app"),
        link: location.href
      }
    });
  },
  methods: {}
};